module.exports = __webpack_public_path__ + "img/arrow-left.ea330ca4.svg";